import React, { useState } from 'react'
import { connect } from 'react-redux'
import { apiResourceEndpoint } from '../../../constants/routes'

import Modal from '../../utils/modal'
import InputElement from '../../utils/input'

const mapStateToProps = (state, ownProps) => {
    const answer = state.answers.find(a => a.questionId === ownProps.question.id && a.installationId === ownProps.installation.id)
    let answerValue = null
    if (answer) {
        answerValue = state.answerValues.find(av => av.answerId === answer.id)
    }
    return {
        answer,
        answerValue,
        image: state.images.find(img => img.id === ownProps.example.imageId)
    }
}

const ExamplePhoto = ({ example, image, answer, answerValue }) => {
    const [showModal, setShowModal] = useState(false)
    let inputId = `answer_${answer?.id}`
    if (answerValue) {
        inputId = inputId + '_' + answerValue.id
    }

    return (
        <>
            <div className="input-content input-wrapper">
                <span className="form-label">Reference Photo</span>
                <p>{example.caption}</p>
                <div className="example-photo image-wrapper" style={{ marginTop: '1rem' }} onClick={()=> setShowModal(true)}>
                    <img src={process.env.REACT_APP_API_URL + apiResourceEndpoint(`questions`, 'VIEW', example.questionId, `example-photo/${image.id}`).url + '?style=thumbnail'} alt="answer value" />
                </div>
                <InputElement
                    type="hidden"
                    id={inputId}
                    label={null}
                    extraClass="d-none"
                    default="READ" />
                { showModal &&
                <Modal closeAction={() => setShowModal(false)}>
                    <p>{example.caption}</p>
                    <img src={process.env.REACT_APP_API_URL + apiResourceEndpoint(`questions`, 'VIEW', example.questionId, `example-photo/${image.id}`).url + '?style=large'} alt="answer value" />
                </Modal>
                }
            </div>
        </>
    )
}

export default connect(mapStateToProps)(ExamplePhoto)
